export default __webpack_public_path__ + "static/media/logo-white.ed2fc02b.svg";